import { generateAPI } from "../api.generator";
import { UploadedAttachment } from "../../types/ticket";

// POST /support-ticket/mine/upload — reused for support-chat attachments. The
// endpoint just stores an image in R2 and returns its public URL; it is not
// ticket-specific. Multipart "file" field.
export const uploadSupportAttachment = generateAPI<
  { params: "upload"; body: FormData },
  UploadedAttachment
>("post", "support-ticket/mine");
